import { Box, styled } from '@mui/material'

export const StyledGhost = styled(Box)(({ theme }) => ({
  position: 'relative',
  '.ghost': {
    pointerEvents: 'none',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: 0,
  },
  '&.nowrap': {
    whiteSpace: 'nowrap',
  },
  ['@media (hover)']: {
    '&:hover': {
      '.ghost': {
        opacity: 1,
      },
      '.prime': {
        opacity: 0,
      },
    },
  },
  '&.center': {
    '.ghost': {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
}))
